
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new-landing",
      function () {
        return require("private-next-pages/new-landing/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new-landing"])
      });
    }
  